// ConfirmDialog.js
const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmLabel = "Confirm",
    cancelLabel = "Cancel", isDestructive, isLoading }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-full max-w-md p-6 mx-4 bg-white rounded-xl">
                <h3 className="mb-2 text-xl font-semibold text-amber-900">{title}</h3>

                {isLoading ? (
                    <div className="mb-6">
                        <div className="flex items-center justify-center p-4 space-x-3 text-amber-600">
                            <div className="w-4 h-4 border-2 rounded-full border-amber-600 animate-spin border-t-transparent"></div>
                            <p>Updating order status and sending notifications...</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <p className="mb-6 text-gray-600">{message}</p>
                        {isDestructive && (
                            <p className="p-3 mb-4 text-sm font-medium text-red-600 rounded-lg bg-red-50">
                                Warning: This action cannot be undone!
                            </p>
                        )}
                    </>
                )}

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isLoading}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg ${isDestructive
                                ? 'bg-red-500 hover:bg-red-600'
                                : 'bg-amber-500 hover:bg-amber-600'
                            } disabled:opacity-50`}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;